import { invalidEmailSubmitted } from 'actions/invalidEmailSubmitted';
import { modalDisplayed } from 'actions/modalDisplayed';
import { showValidationError } from 'actions/validationError';

import { DEFAULT_TIMEOUT_DURATION } from 'consts/appConsts';
import errorMessages, {
  serverInvalidEmailMessage,
} from 'consts/errorMessageConsts';
import responseTypes from 'consts/responseConsts';

import { resetArkose } from 'hooks/useArkose';

import isExpiredSession from 'requests/isExpiredSession';

import { handleNullResponse } from 'thunks/handleNullResponse';

import doRedirect from 'utils/redirectHelper';
import { trackEnrollmentErrorShown } from 'utils/segment/trackingEvents';

export function handleUnsuccessfulFormSubmit(
  res,
  displayErrorMessage,
  useNewValidationHandling = false
) {
  const newDisplayErrorMessage = displayErrorMessage ?? true;

  return dispatch => {
    if (!res) {
      return dispatch(handleNullResponse());
    }

    const { error, errorCode, redirect_url: redirectUrl, status } = res;

    const serverErrorMessage =
      typeof error === 'object' ? error?.message : error;

    if (serverErrorMessage === serverInvalidEmailMessage) {
      /** Reset Arkose if this error comes back from the
       * server because the user will be put back on the email page
       * and for them to be able to re-submit, we have to reset
       * Arkose so they can get a new single use token. */
      resetArkose();
      dispatch(invalidEmailSubmitted());
    }

    if (isExpiredSession(errorCode)) {
      return responseTypes.SESSION_TIMEOUT;
    }

    let errorDisplayMessage =
      serverErrorMessage && typeof serverErrorMessage === 'string'
        ? serverErrorMessage
        : errorMessages.GENERAL_ERROR_MESSAGE;

    // Display error modal if response fails
    if (newDisplayErrorMessage) {
      if (
        useNewValidationHandling &&
        serverErrorMessage === errorMessages.INVALID_USPS_ADDRESS
      ) {
        dispatch(
          showValidationError({ field: 'address', errorType: 'invalid' })
        );
      } else {
        dispatch(modalDisplayed(errorDisplayMessage));
      }
    }

    trackEnrollmentErrorShown(errorDisplayMessage);

    if (redirectUrl) {
      setTimeout(() => {
        // Current assumption is that we will always want to redirect to the legacy app
        doRedirect(redirectUrl, { navigateToLegacyApp: true, clearData: true });
      }, DEFAULT_TIMEOUT_DURATION);
    }

    // if res.status is 200, then server error is due to invalid data being submitted
    if (status === 200) {
      return responseTypes.INVALID_DATA;
    }

    return Promise.reject(res);
  };
}
